<template>
	<!-- 完结精品更多 -->
	<div>
		<!-- 头部 -->
		<van-sticky>
			<div class="headerBox">
				<div class="headerQuery">
					<div class="arrImg" @click="backUrl">
						<img src="../../assets/img/leftarr_tit.png" alt="">
					</div>
					<p class="header_titile">完结精品</p>
				</div>
			</div>
		</van-sticky>
		<div class="limitBox">
			<van-tabs v-model="active" animated swipeable @change="swiperableFn">
				<!-- <van-tab v-for="(item,index) in tabbarLists" :title="item"> -->
				<van-tab title="言情完结精品">
					<van-pull-refresh v-model="isLoading" @refresh="onRefresh" loosing-text="正在获取">
						<!-- 言情完结 -->
						<van-list v-model="loading" :finished="finished" :finished-text="finishedtxt" @load="onLoadYq">
							<div class="xiandaiyanqingBox">
								<div class="blockBox" v-if="yqwjjp_bookInfoList.length != 0 ? true : false">
									<div class="blockLeft" v-for="(item_yqwjjp,yqIndex) in yqwjjp_bookInfoList" :key="yqIndex" @click="jumpBookinfo(item_yqwjjp.book_id,active)">
										<div class="book_Img">
											<img :src="$api.$BASE_URL_img + item_yqwjjp.cover_image" alt="" />
										</div>
										<div class="blockBookInfo">
											<div class="bookName">
												<span class="bookTxtBox" v-if="item_yqwjjp.book_name">
													<van-notice-bar scrollable :text="item_yqwjjp.book_name"></van-notice-bar>
												</span>
												<span class="bookTxtBox" v-else>
													<van-notice-bar scrollable :text="item_yqwjjp.book_name"></van-notice-bar>
												</span>
											</div>
											<div class="auther"><span>{{item_yqwjjp.author}}</span>
											<p><span>{{Math.floor((item_yqwjjp.total_words / 10000) * 100) / 100}}万字</span><span>{{item_yqwjjp.progress_status_name}}</span></p></div>
											<p class="bookType">{{item_yqwjjp.original_name != undefined ? item_yqwjjp.original_name : '无'}}-{{item_yqwjjp.appetency_name != undefined  ? item_yqwjjp.appetency_name : '无'}}-{{item_yqwjjp.epoch_name != undefined  ? item_yqwjjp.epoch_name : '无'}}-{{item_yqwjjp.type_name != undefined  ? item_yqwjjp.type_name : '无'}}</p>
											<div class="introduction">
												<p>{{item_yqwjjp.introduce}}</p>
											</div>
											<div class="book_button">
												<button v-for="(labelItm,labelIdx) in item_yqwjjp.lable_name_list">{{labelItm}}</button>
											</div>
										</div>
									</div>
								</div>
								<div v-if="yqwjjp_bookInfoList.length == 0 ? true : false" style="text-align: center;margin-top: 100px;">
									<img src="../../assets/img/data_null.png" width="100" alt="">
								</div>
							</div>
						</van-list>
					</van-pull-refresh>
				</van-tab>
				<van-tab title="纯爱完结精品">
					<!-- 纯爱完结-->
					<van-pull-refresh v-model="isLoading" @refresh="onRefresh01" loosing-text="正在获取">
						<van-list v-model="loading" :finished="finished" :finished-text="finishedtxt" @load="onLoadCa">
							<div class="xiandaiyanqingBox">
								<div class="blockBox" v-if="cawjjp_bookInfoList.length != 0 ? true : false">
									<div class="blockLeft" v-for="(item_cawjjp,index) in cawjjp_bookInfoList" :key="index" @click="jumpBookinfo(item_cawjjp.book_id,active)">
										<div class="book_Img">
											<img :src="$api.$BASE_URL_img + item_cawjjp.cover_image" alt="" />
										</div>
										<div class="blockBookInfo">
											<div class="bookName">
												<span class="bookTxtBox" v-if="item_cawjjp.book_name">
													<van-notice-bar scrollable :text="item_cawjjp.book_name"></van-notice-bar>
												</span>
												<span class="bookTxtBox" v-else>
													<van-notice-bar scrollable :text="item_cawjjp.book_name"></van-notice-bar>
												</span>
											</div>
											<div class="auther">
											<span>{{item_cawjjp.author}}</span>
											<p><span>{{Math.floor((item_cawjjp.total_words / 10000) * 100) / 100}}万字</span><span>{{item_cawjjp.progress_status_name}}</span></p></div>
											<p class="bookType">{{item_cawjjp.original_name != undefined ? item_cawjjp.original_name : '无'}}-{{item_cawjjp.appetency_name != undefined  ? item_cawjjp.appetency_name : '无'}}-{{item_cawjjp.epoch_name != undefined  ? item_cawjjp.epoch_name : '无'}}-{{item_cawjjp.type_name != undefined  ? item_cawjjp.type_name : '无'}}</p>
											<div class="introduction">
												<p>{{item_cawjjp.introduce}}</p>
											</div>
											<div class="book_button">
												<button v-for="(labelItm,labelIdx) in item_cawjjp.lable_name_list">{{labelItm}}</button>
											</div>
										</div>
									</div>
								</div>
								<div v-if="cawjjp_bookInfoList.length == 0  ? true : false" style="text-align: center;margin-top: 100px;">
									<img src="../../assets/img/data_null.png" width="100" alt="">
								</div>
							</div>
						</van-list>
					</van-pull-refresh>
				</van-tab>
				<van-tab title="衍生完结精品">
					<!-- 衍生完结 -->
					<van-pull-refresh v-model="isLoading" @refresh="onRefresh02" loosing-text="正在获取">
						<van-list v-model="loading" :finished="finished" :finished-text="finishedtxt" @load="onLoadYs">
							<div class="xiandaiyanqingBox">
								<div class="blockBox" v-if="yswjjp_bookInfoList.length != 0 ? true : false">
									<div class="blockLeft" v-for="(item_yswjjp,index) in yswjjp_bookInfoList" :key="index" @click="jumpBookinfo(item_yswjjp.book_id,active)">
										<div class="book_Img">
											<img :src="$api.$BASE_URL_img + item_yswjjp.cover_image" alt="" />
										</div>
										<div class="blockBookInfo">
											<div class="bookName">
												<span class="bookTxtBox" v-if="item_yswjjp.book_name">
													<van-notice-bar scrollable :text="item_yswjjp.book_name"></van-notice-bar>
												</span>
												<span class="bookTxtBox" v-else>
													<van-notice-bar scrollable :text="item_yswjjp.book_name"></van-notice-bar>
												</span>
											</div>
											<div class="auther">
												<span>{{item_yswjjp.author}}</span>
												<p><span>{{Math.floor((item_yswjjp.total_words / 10000) * 100) / 100}}万字</span><span>{{item_yswjjp.progress_status_name}}</span></p></div>
											<p class="bookType">{{item_yswjjp.original_name != undefined ? item_yswjjp.original_name : '无'}}-{{item_yswjjp.appetency_name != undefined  ? item_yswjjp.appetency_name : '无'}}-{{item_yswjjp.epoch_name != undefined  ? item_yswjjp.epoch_name : '无'}}-{{item_yswjjp.type_name != undefined  ? item_yswjjp.type_name : '无'}}</p>
											<div class="introduction">
												<p>{{item_yswjjp.introduce}}</p>
											</div>
											<div class="book_button">
												<button v-for="(labelItm,labelIdx) in item_yswjjp.lable_name_list">{{labelItm}}</button>
											</div>
										</div>
									</div>
								</div>
								<div v-if="yswjjp_bookInfoList.length == 0 ? true : false" style="text-align: center;margin-top: 100px;">
									<img src="../../assets/img/data_null.png" width="100" alt="">
								</div>
							</div>
						</van-list>
					</van-pull-refresh>
				</van-tab>
				<van-tab title="VIP新文总榜">
					<!-- VIP新文总榜 -->
					<van-pull-refresh v-model="isLoading" @refresh="onRefresh03" loosing-text="正在获取">
						<van-list v-model="loading" :finished="finished" :finished-text="finishedtxt" @load="onLoad">
							<div class="xiandaiyanqingBox">
								<div class="blockBox" v-if="vipZb_bookInfoList.length != [] ? true : false">
									<div class="blockLeft" v-for="(item_vip,index) in vipZb_bookInfoList" :key="index" @click="jumpBookinfo(item_vip.book_id,active)">
										<div class="book_Img">
											<img :src="$api.$BASE_URL_img + item_vip.cover_image" alt="" v-if="item_vip.cover_image != ''" />
										</div>
										<div class="blockBookInfo">
											<div class="bookName">
												<span class="bookTxtBox" v-if="item_vip.book_name">
													<van-notice-bar scrollable :text="item_vip.book_name"></van-notice-bar>
												</span>
												<span class="bookTxtBox" v-else>
													<van-notice-bar scrollable :text="item_vip.book_name"></van-notice-bar>
												</span>
											</div>
											<div class="auther"><span>{{item_vip.author}}</span>
											<p><span>{{Math.floor((item_vip.total_words / 10000) * 100) / 100}}万字</span><span>{{item_vip.progress_status_name}}</span></p></div>
											<p class="bookType">{{item_vip.original_name != undefined ? item_vip.original_name : '无'}}-{{item_vip.appetency_name != undefined  ? item_vip.appetency_name : '无'}}-{{item_vip.epoch_name != undefined  ? item_vip.epoch_name : '无'}}-{{item_vip.type_name != undefined  ? item_vip.type_name : '无'}}</p>
											<div class="introduction">
												<p>{{item_vip.introduce}}</p>
											</div>
											<div class="book_button">
												<button v-for="(labelItm,labelIdx) in item_vip.lable_name_list">{{labelItm}}</button>
											</div>
										</div>
									</div>
								</div>
								<div v-if="vipZb_bookInfoList.length == 0 ? true : false" style="text-align: center;margin-top: 100px;">
									<img src="../../assets/img/data_null.png" width="100" alt="">
								</div>
							</div>
						</van-list>
					</van-pull-refresh>
				</van-tab>
			</van-tabs>
		</div>
	</div>
</template>

<script>
	import {
		Toast
	} from 'vant'
	export default {
		components: {},
		data() {
			return {
				active: 0,
				jumpUrl: '',
				tabbarLists: ["言情完结精品", "纯爱完结精品", "衍生完结精品", "VIP新文总榜"],
				yqwjjp_bookInfoList: [], // 言情完结
				cawjjp_bookInfoList: [], //纯爱完结
				yswjjp_bookInfoList: [], //衍生完结
				vipZb_bookInfoList: [], //vip总榜
				isLoading: false,
				page: 1, //vip
				pageYs: 1, //衍生
				pageCa: 1, //纯爱
				pageYq: 1, //言情
				yqTotal: 0,
				caTotal: 0,
				ysTotal: 0,
				vipTotal: 0,
				limit: 10,
				onFooter: false,
				onPullDown: true, //下拉加载
				loading: false,
				finished: false,
				refreshing: false,
				finishedtxt: '没有更多了',
			}
		},
		created() {
			this.active = this.$route.query.active;
			this.jumpUrl = this.$route.query.cityPage || this.$route.query.bookshelfUrl;
			if (this.active == 0) {
				this.yqwjjpFn(); // 言情完结
			} else if (this.active == 1) {
				this.cawjjpFn(); //纯爱完结
			} else if (this.active == 2) {
				this.yswjjpFn(); //衍生完结
			} else if (this.active == 3) {
				this.vipZbFn();
			}
		},
		mounted() {
			// if (this.active == 0) {
			// 	this.yqwjjpFn(); // 言情完结
			// } else if (this.active == 1) {
			// 	this.cawjjpFn(); //纯爱完结
			// } else if (this.active == 2) {
			// 	this.yswjjpFn(); //衍生完结
			// }else if (this.active == 3) {
			// 	this.vipZbFn();
			// }
			// window.addEventListener('scroll', this.scroll, false) // 监听（绑定）滚轮滚动事件
		},
		methods: {
			// 滚动加载分页
			scroll() {
				// debugger
				var that = this
				// scrollTop 滚动条滚动时，距离顶部的距离
				var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
				var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
				// windowHeight 可视区的高度
				var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
				// scrollHeight 滚动条的总高度
				var scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
				// 滚动条到底部的条件
				if (scrollTop + windowHeight == scrollHeight && that.onPullDown == true) {
					// 加载数据 
					that.page = that.page + 1;
					if (that.active == 0) {
						that.yqwjjpFn(); // 言情完结
					} else if (that.active == 1) {
						that.cawjjpFn(); //纯爱完结
					} else if (that.active == 2) {
						that.yswjjpFn(); //衍生完结
					} else if (that.active == 3) {
						that.vipZbFn();
					}
				}
			},
			onLoad() { //vip
				if (this.vipZb_bookInfoList.length <= this.vipTotal) {
					this.page += 1; //页数+1
					this.vipZbFn();
				}
			},
			onLoadYs() { //衍生
				if (this.yswjjp_bookInfoList.length <= this.ysTotal) {
					this.pageYs += 1; //页数+1
					this.yswjjpFn();
				}
			},
			onLoadCa() { //纯爱
				if (this.cawjjp_bookInfoList.length <= this.caTotal) {
					this.pageCa += 1; //页数+1
					this.cawjjpFn();
				}
			},
			onLoadYq() { //言情
				if (this.yqwjjp_bookInfoList.length <= this.yqTotal) {
					this.pageYq += 1; //页数+1
					this.yqwjjpFn();
				}
			},
			backUrl() {
				// if (this.jumpUrl == 'cityPageUrl') {
				// 	this.$router.push('/bookcity');
				// }else if(this.jumpUrl == 'bookshelfUrl'){
				// 	this.$router.push('/bookcity');
				// }else {
				// 	this.$router.push('/bookcity');
				// }
				this.$router.push('/bookcity');
			},
			onRefresh() {
				setTimeout(() => {
					Toast('刷新成功');
					this.pageYq = 1;
					this.yqwjjpFn();
					this.isLoading = false;
				}, 1000);
			},
			onRefresh01() {
				setTimeout(() => {
					Toast('刷新成功');
					this.pageCa = 1; //页数+1
					this.cawjjpFn();
					this.isLoading = false;
				}, 1000);
			},
			onRefresh02() {
				setTimeout(() => {
					Toast('刷新成功');
					this.pageYs = 1; //页数+1
					this.yswjjpFn();
					this.isLoading = false;
				}, 1000);
			},
			onRefresh03() {
				setTimeout(() => {
					Toast('刷新成功');
					this.page = 1; //页数+1
					this.vipZbFn();
					this.isLoading = false;
				}, 1000);
			},
			jumpBookinfo(id, index) {
				console.log(id, index)
				this.$router.push({
					path: '/bookinfo',
					query: {
						url: 'wanjiejinpinMore',
						id: id,
						active: index
					}
				})
			},
			swiperableFn(name, title) {
				this.active = name;
				if (name == 0) {
					this.pageYq = 0;
					this.onLoadYq();
				} else if (name == 1) {
					this.pageCa = 0;
					this.onLoadCa();
				} else if (name == 2) {
					this.pageYs = 0;
					this.onLoadYs();
				} else if (name == 3) {
					this.page = 0;
					this.onLoad();
				}
			},
			// 言情完结
			yqwjjpFn() {
				this.$axios.post(this.$api.ranking_qywj, {
					page: this.pageYq,
					limit: this.limit,
					plate_info_id: 84,
				}).then(res => {
					this.yqTotal = res.data.data.total;
					if (this.yqwjjp_bookInfoList.length <= 10 || res.data.data.total <= 10) {
						this.yqwjjp_bookInfoList = res.data.data.plate_list;
					} else {
						this.yqwjjp_bookInfoList = this.yqwjjp_bookInfoList.concat(res.data.data.plate_list) || [];
					}
					if (res.data.data.total == 0) {
						this.finishedtxt = "暂无数据";
						this.finished = true;
					} else if (res.data.data.plate_list.length == 0 || res.data.data.plate_list.length <= 10) { //数据全部加载完成
						this.finished = true;
					} else {
						this.finished = false;
					}
				})
			},
			// 纯爱
			cawjjpFn() {
				this.$axios.post(this.$api.ranking_qywj, {
					page: this.pageCa,
					limit: this.limit,
					plate_info_id: 85,
				}).then(res => {
					this.caTotal = res.data.data.total;
					if (this.cawjjp_bookInfoList.length <= 10 || res.data.data.total <= 10) {
						this.cawjjp_bookInfoList = res.data.data.plate_list;
					} else {
						this.cawjjp_bookInfoList = this.cawjjp_bookInfoList.concat(res.data.data.plate_list);
					}
					this.loading = false;

					if (res.data.data.total == 0) {
						this.finishedtxt = "暂无数据";
						this.finished = true;
					} else if (res.data.data.plate_list.length == 0 || res.data.data.plate_list.length <= 10) { //数据全部加载完成
						this.finished = true;
					} else {
						this.finished = false;
					}
				})
			},
			// 衍生
			yswjjpFn() {
				this.$axios.post(this.$api.ranking_qywj, {
					page: this.pageYs,
					limit: this.limit,
					plate_info_id: 86,
				}).then(res => {
					this.ysTotal = res.data.data.total;
					if (this.yswjjp_bookInfoList.length <= 10 || res.data.data.total <= 10) {
						this.yswjjp_bookInfoList = res.data.data.plate_list;
					} else {
						this.yswjjp_bookInfoList = this.yswjjp_bookInfoList.concat(res.data.data.plate_list);
					}
					this.loading = false;
					if (res.data.data.total == 0) {
						this.finishedtxt = "暂无数据";
						this.finished = true;
					} else if (res.data.data.plate_list.length == 0 || res.data.data.plate_list.length <= 10) { //数据全部加载完成
						this.finished = true;
					} else {
						this.finished = false;
					}
				})
			},
			// vip
			vipZbFn() {
				this.$axios.post(this.$api.ranking_qywj, {
					page: this.page,
					limit: this.limit,
					plate_info_id: 87,
				}).then(res => {
					this.vipTotal = res.data.data.total;
					if (this.vipZb_bookInfoList.length <= 10 || res.data.data.total <= 10) {
						this.vipZb_bookInfoList = res.data.data.plate_list;
					} else {
						this.vipZb_bookInfoList = this.vipZb_bookInfoList.concat(res.data.data.plate_list);
					}
					this.loading = false;
					if (res.data.data.total == 0) {
						this.finishedtxt = "暂无数据";
						this.finished = true;
					} else if (res.data.data.plate_list.length == 0 || res.data.data.plate_list.length <= 10) { //数据全部加载完成
						this.finished = true;
					} else {
						this.finished = false;
					}
				})
			},
		},
		destroyed() {
			window.removeEventListener('scroll', this.scroll) //  离开页面清除（移除）滚轮滚动事件
		}
	}
</script>


<style>
	.van-tabs__line {
		background-color: transparent;
	}

	.van-tab--active {
		color: #ff4081;
		transform: scale(1.1);
		font-weight: 600;
	}
</style>
<style lang="less" scoped>
	.limitBox {
		height: calc(100vh - 160px);
	}

	/deep/.van-tabs--line .van-tabs__wrap {
		position: fixed;
		top: 160px;
		z-index: 100;
		width: 100%;
	}

	/deep/.van-tabs__content--animated {
		margin-top: 80px;
	}

	// 头部
	.headerBox {
		height: 160px;
		// background-color: #ff4081;
		display: flex;
		background: url(../../assets/img/myicon/indexBgc.png) no-repeat 0% 88% #fff;
		background-size: 100%;
		border-bottom: 1px solid #f0f0f0;

		/*no*/
		.headerQuery {
			margin-top: 70px;
			padding: 0 16px;
			position: relative;
			display: flex;
			width: 100%;
			height: 90px;
			line-height: 90px;
			color: #000;

			.arrImg {
				img {
					width: 40px;
					position: absolute;
					top: 50%;
					transform: translateY(-50%);
					left: 0px;
				}
			}

			.header_titile {
				flex: 1;
				text-align: center;
				font-size: 34px;
				/*px*/
			}
		}

	}

	.xiandaiyanqingBox {
		margin-top: 6px;

		/*px*/
		//列表数据
		.blockBox {
			overflow: hidden;
			position: relative;
			background-color: #fff;
			padding: 0px 16px;

			.blockLeft {
				display: flex;
				background-color: #fff;
				padding: 20px 0px;
				padding-bottom: 20px;
				border-bottom: 1px solid #f0f0f0;

				/*no*/
				.book_Img {
					width: 172px;
					height: 280px;
					display: block;
					float: left;
					-webkit-box-shadow: 0 0 4px 0 rgba(0, 0, 0, .2);
					/*no*/
					-moz-box-shadow: 0 0 4px 0 rgba(0, 0, 0, .2);
					/*no*/
					box-shadow: 0 0 4px 0 rgba(0, 0, 0, .2);

					/*no*/
					img {
						width: 172px;
						height: 280px;
						// display: block;
						// float: left;
						// -webkit-box-shadow: 0 0 4px 0 rgba(0, 0, 0, .2);
						// /*no*/
						// -moz-box-shadow: 0 0 4px 0 rgba(0, 0, 0, .2);
						// /*no*/
						// box-shadow: 0 0 4px 0 rgba(0, 0, 0, .2);
						// /*no*/
					}
				}

				.blockBookInfo {
					margin-left: 20px;
					flex: 1;
					font-size: 26px;
					/*px*/
					line-height: 30px;

					.auther {
						color: #000;
						font-size: 26px;
						/*px*/
						opacity: 0.6;
						/*px*/
						p {
							display: inline-block;
							float: right;
							font-weight: 400;
						
							span {
								margin-left: 8px;
								color: #000;
								font-size: 26px;
								/*px*/
							}
						
							// .wanjie {
							// 	color: #ff0000;
							// }
						
							// .txtGreen {
							// 	color: #5ca615;
							// }
						}
					}

					.bookName {
						// line-height: 40px;
						padding-bottom: 20px;
						font-size: 30px;
						/*px*/
						// font-weight: 600;
						.bookTxtBox {
							width: calc(100vw - 260px);
							font-size: 30px;
							/*px*/
							color: #000;
							overflow: hidden;
							display: inline-block;
							.van-swipe .van-swipe__track--vertical .van-swipe-item {
								overflow: hidden;
								white-space: nowrap;
								text-overflow: ellipsis;
							}
						
							.van-notice-bar {
								background: rgba(0, 0, 0, 0);
								color: #000;
								height: 30px;
								padding: 0;
							}
						}
					}

					.bookType,
					.introduction {
						padding-top: 20px;
						color: #000;
						font-size: 24px;
						/*px*/
						opacity: 0.4;
					}

					.introduction {
						width: 60vw;
						padding-top: 15px;

						p {
							overflow: hidden;
							white-space: nowrap;
							text-overflow: ellipsis;
						}
					}

					.book_button {
						margin-top: 15px;
						align-items: center;

						button {
							border: 0;
							outline: none;
							border: 1px solid #fec6d5;
							/*no*/
							border-radius: 28px;
							padding: 0px 20px;
							display: inline-block;
							line-height: 36px;
							/*px*/
							background-color: #fff8fa;
							color: #fa7298;
							margin-right: 20px;
							font-size: 24px;
							/*px*/
							overflow: hidden;
							text-overflow: ellipsis;
							white-space: nowrap;
							margin-bottom: 10px;
						}

						.active {
							background-color: #fa7298;
							color: #ffffff;
						}
					}
				}
			}

		}
	}
</style>
